;( function() {

	// ——————————————————————
	// Helpers for "Show all / Show less" toggles
	// ——————————————————————
	function toggleListItems( event, listItems, toggleLink, maxVisible, isExpandedRef ) {
		event.preventDefault();
		isExpandedRef.value = !isExpandedRef.value;
		listItems.forEach( ( li, idx ) => {
			li.style.display = ( idx < maxVisible || isExpandedRef.value )
							   ? ''
							   : 'none';
		} );

		// Count only non-separator items
		const nonSepCount = listItems.reduce(
			( n, li ) => n + ( li.classList.contains( 'is-separator' ) ? 0 : 1 ),
			0
		);

		const icon = isExpandedRef.value
					 ? '<i class="fa-regular fa-minus"></i>'
					 : '<i class="fa-regular fa-plus"></i>';
		toggleLink.innerHTML = `${icon} ${isExpandedRef.value
										  ? 'Show less features'
										  : 'Show all ' + nonSepCount + ' features'}`;
	}

	function getListShorteningToggle( ul, maxVisible = 4 ) {
		const listItems = Array.from( ul.querySelectorAll( 'li' ) );
		const nonSepCount = listItems.reduce(
			( n, li ) => n + ( li.classList.contains( 'is-separator' ) ? 0 : 1 ),
			0
		);
		if ( nonSepCount <= maxVisible ) return null;
		// hide extras
		listItems.forEach( ( li, i ) => {
			if ( i >= maxVisible ) li.style.display = 'none';
		} );
		const isExpandedRef = { value: false };
		const toggleLink = document.createElement( 'a' );
		toggleLink.href = '#';
		toggleLink.className = 'toggle-features';
		toggleLink.innerHTML = '<i class="fa-regular fa-plus"></i> Show all ' + nonSepCount + ' features';
		toggleLink.addEventListener( 'click', e =>
			toggleListItems( e, listItems, toggleLink, maxVisible, isExpandedRef )
		);
		return toggleLink;
	}

	// ——————————————————————
	// Collect per-view resize handlers
	// ——————————————————————
	const resizeHandlers = [];
	window.addEventListener( 'resize', () => resizeHandlers.forEach( fn => fn() ) );

	// ——————————————————————
	// Init a single comparison view
	// ——————————————————————
	function initComparisonView( view ) {
		const fixedCon = view.querySelector( '.comparison-grid__fixed' );
		const sliderCon = view.querySelector( '.comparison-grid__slider' );

		let swiperInstance;

		const colCount = parseInt( view.dataset.columnCount, 10 ) || 2;
		const slidesCount = sliderCon.querySelectorAll( '.swiper-slide' ).length;

		/**
		 * Expand/collapse and reflow while keeping `el` locked
		 * at the same viewport position.
		 */
		function keepInPlace( el, fn ) {
			// 1) Snapshot
			const prevRect = el.getBoundingClientRect();
			const prevTop = prevRect.top;
			const prevScroll = window.scrollY;

			// 2) Do your DOM mutations (toggle + match)
			fn();

			// 3) After layout, compute shift and correct scroll
			requestAnimationFrame( () => {
				const newTop = el.getBoundingClientRect().top;
				const delta = newTop - prevTop;
				if ( delta !== 0 ) {
					window.scrollTo( {
						top: prevScroll + delta,
						left: window.scrollX,
						behavior: 'auto'
					} );
				}
			} );
		}

		function matchRowHeights() {
			const stickyRows = fixedCon.querySelectorAll( '.comparison-row' );
			const slides = sliderCon.querySelectorAll( '.swiper-slide' );
			stickyRows.forEach( r => r.style.height = '' );
			slides.forEach( slide => slide.querySelectorAll( '.comparison-row' )
			.forEach( r => r.style.height = '' ) );

			stickyRows.forEach( ( row, idx ) => {
				let maxH = row.offsetHeight;
				slides.forEach( slide => {
					const match = slide.querySelectorAll( '.comparison-row' )[ idx ];
					if ( match ) maxH = Math.max( maxH, match.offsetHeight );
				} );
				row.style.height = maxH + 'px';
				slides.forEach( slide => {
					const match = slide.querySelectorAll( '.comparison-row' )[ idx ];
					if ( match ) match.style.height = maxH + 'px';
				} );
			} );
		}

		function switchToDesktop() {
			view.querySelector( '.comparison-grid' ).style.display = 'flex';
			const cards = view.querySelector( '.comparison-cards' );
			if ( cards ) cards.style.display = 'none';
		}

		function switchToMobile() {
			if ( !prepareMobileView() ) return;
			view.querySelector( '.comparison-grid' ).style.display = 'none';
			view.querySelector( '.comparison-cards' ).style.display = 'flex';
		}

		function onResize() {
			if ( window.innerWidth < 700 ) {
				switchToMobile();
			} else {
				switchToDesktop();
				matchRowHeights();
			}
		}

		/**
		 * @param {HTMLElement} wrapper  The .slider-container that
		 *                               has the ::after fade on it
		 * @param {Swiper}      swiper   The swiper instance
		 */
		function updateFade( wrapper, swiper ) {
			// when we're at the end slide → kill the fade
			wrapper.classList.toggle( 'no-left-fade', swiper.isBeginning );
			wrapper.classList.toggle( 'no-right-fade', swiper.isEnd );
		}

		/**
		 * Returns true if `root` has no descendants other than <i> elements
		 * (ignoring whitespace‐only text nodes). Otherwise returns false.
		 *
		 * @param {Element} root
		 * @return {boolean}
		 */
		function onlyIconElementsDescend( root ) {
			// Use a TreeWalker to examine all descendant nodes
			const walker = document.createTreeWalker(
				root,
				NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
				{
					acceptNode( node ) {
						// If it’s a text node with only whitespace, ignore it
						if ( node.nodeType === Node.TEXT_NODE ) {
							return node.textContent.trim() === ""
								   ? NodeFilter.FILTER_SKIP
								   : NodeFilter.FILTER_ACCEPT;
						}
						// If it’s an element but not <i>, reject
						if ( node.nodeType === Node.ELEMENT_NODE && node.tagName !== "I" ) {
							return NodeFilter.FILTER_ACCEPT; // we’ll catch this as “bad”
						}
						// Otherwise (an <i> element), skip
						return NodeFilter.FILTER_SKIP;
					}
				},
				false
			);

			// Walk through the tree—if we find any “accepted” node, it means it was
			// either non‐whitespace text or an element that isn’t <i>.
			return walker.nextNode() === null;
		}

		function appendWhatever( parent, thing ) {
			if ( !thing ) return;

			// 1) NodeList / HTMLCollection / Array → recurse
			if (
				thing instanceof NodeList ||
				thing instanceof HTMLCollection ||
				Array.isArray( thing )
			) {
				for ( let i = 0; i < thing.length; i ++ ) {
					appendWhatever( parent, thing[ i ] );
				}

				// 2) Element or DocumentFragment → deep-clone (preserves children)
			} else if (
				thing instanceof Element ||
				thing instanceof DocumentFragment
			) {
				parent.appendChild( thing.cloneNode( true ) );

				// 3) Any other Node (TextNode, Comment, etc.) → shallow-clone
			} else if ( thing instanceof Node ) {
				parent.appendChild( thing.cloneNode( false ) );

				// 4) String → text node
			} else if ( typeof thing === 'string' && thing !== '' ) {
				parent.appendChild( document.createTextNode( thing ) );
			}
		}

		/**
		 *
		 * @param node
		 * @param prefix
		 * @param value
		 * @param suffix
		 */
		/**
		 * Append prefix + value + suffix into a container node,
		 * where each of prefix/value/suffix may be:
		 *   • a string (to insert as text)
		 *   • a DOM node (to insert as node)
		 *   • null or empty (to skip)
		 *
		 * @param {HTMLElement} container The element you want to append into.
		 * @param {string|Node|null} prefix  Optional text or node to insert first.
		 * @param {string|Node|null} value   The main text or node (if null, do nothing).
		 * @param {string|Node|null} suffix  Optional text or node to insert after.
		 */
		function append( container, prefix = '', value = null, suffix = '' ) {
			appendWhatever( container, prefix );
			appendWhatever( container, value );
			appendWhatever( container, suffix );
		}

		function getDesktopContent( cell ) {
			return Array.from( cell.childNodes ).find( node => {
				// 1) If it’s a text node, check it has some non‐whitespace text
				if ( node.nodeType === Node.TEXT_NODE ) {
					return node.textContent.trim() !== '';
				}
				// 2) If it’s an element, ensure it does NOT have “is-mobile”
				if ( node.nodeType === Node.ELEMENT_NODE ) {
					return !node.classList.contains( 'is-mobile' );
				}
				// 3) Otherwise (comments, etc.), skip
				return false;
			} ) || null;
		}

		/**
		 * Remove the first <i> element with a Font-Awesome class from a node list.
		 *
		 * @param {NodeList|HTMLCollection|Array<Node>} nodes
		 */
		// function removeFirstFaIcon(nodes) {
		// 	if ( nodes instanceof NodeList ) {
		// 		for ( const node of nodes ) {
		// 			// Only elements can have tagName/classList
		// 			if ( node.nodeType !== Node.ELEMENT_NODE ) continue;
		//
		// 			// Must be an <i>
		// 			if ( node.tagName.toLowerCase() !== 'i' ) continue;
		//
		// 			// Check for any class starting with "fa"
		// 			const hasFa = Array.from( node.classList ).some( c => c.startsWith( 'fa' ) );
		// 			if ( hasFa ) {
		// 				node.remove();
		// 				break;
		// 			}
		// 		}
		// 	}
		// }

		/**
		 * Remove the first <i> child of `node` that has a class starting with "fa".
		 * @param {Element} node  – the container to search in
		 */
		function removeMobileContent(node) {
			if ( node instanceof Node ) {
				for ( const child of node.childNodes ) {
					// only care about element nodes
					if ( child.nodeType !== Node.ELEMENT_NODE ) continue;
					// stop if it’s not an <i>
					// if any class starts with "fa", remove and exit
					if ( [...child.classList].some( c => c === 'is-mobile' ) ) {
						node.removeChild( child );
					}
					break;
				}
			}
		}

		/**
		 * Find and remove the first <i> child of `node` that has a class starting with "fa",
		 * skipping leading whitespace-only text nodes. Returns the extracted <i> node or null.
		 *
		 * @param {Node} node – The container element to search within.
		 * @returns {Element|null} – The removed <i> Font-Awesome icon, or null if not found.
		 */
		function extractFirstFaIcon(node) {
			if (!(node instanceof Node)) return null;

			for (const child of node.childNodes) {
				// 1) Skip whitespace-only text nodes
				if (child.nodeType === Node.TEXT_NODE) {
					if (child.textContent.trim() === '') {
						continue;
					}
					// Non-empty text means an <i> afterwards isn't "first"
					break;
				}

				// 2) Skip comments or other non-elements
				if (child.nodeType !== Node.ELEMENT_NODE) {
					continue;
				}

				// 3) If first element is not an <i>, stop searching
				if (child.tagName !== 'I') {
					break;
				}

				// 4) It’s an <i>; check for any "fa…" class
				const hasFaClass = [...child.classList].some(c => c.startsWith('fa'));
				if (hasFaClass) {
					node.removeChild(child);
					return child;
				}

				// Found an <i> but no FA classes, so we stop here
				break;
			}

			return null;
		}

		/**
		 *
		 * @returns {boolean}
		 */
		function prepareMobileView() {
			if ( view.querySelector( '.comparison-cards' ) ) return true;

			const bulletPositive = document.createElement( 'i' );
			bulletPositive.classList.add( 'fa-solid', 'fa-circle-check' );
			const bulletNegative = document.createElement( 'i' );
			bulletNegative.classList.add( 'fa-solid', 'fa-circle-check' ); //https://colibrigroup.atlassian.net/browse/FET-4473

			let sliderRows = Array.from( sliderCon.querySelectorAll( '.comparison-row' ) );
			if ( !sliderRows.length ) return false;
			// 2. Exclude the last child if it contains .is-product-link
			const excludeLast = !!sliderRows[ sliderRows.length - 1 ].querySelector( '.is-product-link' );

			let rows = Array.from( fixedCon.querySelectorAll( '.comparison-row' + ( excludeLast ? ':not(:last-child)' : '' ) ) );
			if ( !rows.length ) return false;
			const claims = [];
			rows.forEach( r => {
				const i = +r.dataset.rowIndex;
				if ( i < rows.length ) {
					claims.push( {
						label:     r.querySelector( '.is-claim-label:not(.is-mobile)' )?.textContent.trim(),
						mobLabel:  r.querySelector( '.is-claim-label.is-mobile' )?.textContent.trim(),
						order:     + r.getAttribute( 'data-row-index' ),
						mobOrder:  + r.firstElementChild.getAttribute( 'data-mobile-order' ),
						mobActive: ! r.firstElementChild.hasAttribute( 'data-mobile-disabled' ),
						isSeparator: r.firstElementChild.classList.contains( 'is-separator-claim' )
					} );
				}
			} );

			claims.sort( ( a, b ) => a.mobOrder - b.mobOrder );

			const slides = sliderCon.querySelectorAll( '.swiper-slide' );
			if ( !slides.length ) return false;

			const cardsWrap = document.createElement( 'div' );
			cardsWrap.className = 'comparison-cards';

			const source = view.querySelector( '.comparison-grid__fixed .comparison-row:first-child div' );
			const clones = Array.from( source.children, child => child.cloneNode( true ) );
			cardsWrap.append( ...clones );

			//if a mobile label exists, remove the regular label
			cardsWrap
				.querySelectorAll(`
					.is-claim-label:not(.is-mobile) + .is-claim-label.is-mobile,
					.is-claim-description:not(.is-mobile) + .is-claim-description.is-mobile
				`)
				.forEach( mobile => mobile.previousElementSibling.remove() );

			slides.forEach( slide => {
				const prod = slide.querySelector( '.comparison-row[data-row-index="0"] .colibri-blocks\\/header-cell' );
				const link = slide.querySelector( '.is-product-link:not(:empty)' );

				const card = prod.cloneNode( true );
				card.classList.add( 'card', 'card--package' );

				const ul = document.createElement( 'ul' );
				ul.classList.add( 'claims-list' );

				claims.forEach( ( claim, i ) => {
					if ( !claim.mobActive ) {
						//this claim is not wanted on mobile
						return true;
					}
					const row = slide.querySelector( '.comparison-row[data-row-index="' + claim.order + '"]' );
					const cell = row.querySelector( '.colibri-blocks\\/table-cell' );
					if ( !cell ) {
						return true; //continue - skipping the row that only has header-cells
					}
					const desktopContent = cell.cloneNode( true ); //text or elements that do not have .is-mobile
					const mobileContent = cell.querySelector( ':scope > .is-mobile' );

					const isPositive = cell.classList.contains( 'is-positive' );
					const bullet = isPositive
								   ? bulletPositive.cloneNode( false )
								   : bulletNegative.cloneNode( false );

					const li = document.createElement( 'li' );

					const hasMobile = mobileContent instanceof Node
						&& ( !!mobileContent?.textContent?.trim() || mobileContent?.innerHTML?.includes( '<i ' ) );

					const source = hasMobile
								   ? mobileContent
								   : desktopContent;
					const sourceText = source?.textContent?.trim() || '';
					const ownIcon = extractFirstFaIcon( source );

					var label;
					if ( hasMobile || claim.mobLabel ) {
						//if mobile label is not specified, we will not use the regular label
						label = claim.mobLabel
								? claim.mobLabel + ( sourceText
													 ? ': '
													 : '' )
								: null;

					} else if ( isPositive || sourceText ) {
						label = claim.label + ( ( claim.label && sourceText )
												? ': '
												: '' )
					}

					append(
						li,
						claim.isSeparator
						? ''
						: ( ownIcon
							? ownIcon
							: bullet ),
						label,
						source?.childNodes
						? source.childNodes
						: source
					);

					if ( li.textContent.trim() ) {
						if ( claim.isSeparator ) {
							li.classList.add( 'is-separator' );
						}
						ul.appendChild( li );
					}
				} );

				if ( ul.children.length ) {
					const toggle = getListShorteningToggle( ul );
					const productName = card.querySelector( '.is-product-name' );
					if ( productName ) {
						productName.parentNode.insertBefore( ul, productName.nextSibling );
					} else {
						card.appendChild( ul );
					}
					if ( toggle ) {
						ul.parentNode.insertBefore( toggle, ul.nextSibling );
					}
				}

				const banner = card.querySelector( '.is-product-banner:not(:empty)' );
				if ( banner ) {
					const productName = card.querySelector( '.is-product-name' );
					if ( productName ) {
						productName.parentNode.insertBefore( banner, productName.nextSibling );
					}
				}

				const intro = card.querySelector( '.is-product-intro:not(:empty)' );
				if ( intro ) {
					if ( ul ) {
						ul.parentNode.insertBefore( intro, ul );
					}
				}

				const cta = card.getElementsByClassName( 'add-to-cart-container' )[ 0 ];
				const following = [];
				let sib = cta.nextElementSibling;
				while ( sib ) {
					if ( !sib.classList.contains( 'is-product-outro' ) ) {
						following.push( sib );
					}
					sib = sib.nextElementSibling;
				}

				for ( let i = following.length - 1; i >= 0; i -- ) {
					const clone = following[ i ];
					ul.parentNode.insertBefore( clone, ul );
				}

				if ( link ) {
					const linkClone = link.cloneNode( true );
					linkClone.classList.add( 'cds-button', 'cds-button--cta' );
					card.appendChild( linkClone );
				}

				cardsWrap.appendChild( card );
			} );

			view.querySelector( '.comparison-grid' ).after( cardsWrap );
			if ( window.affirm?.ui ) window.affirm.ui.ready( () => window.affirm.ui.refresh() );

			// the passed detail is to be extracted like this:
			// const [wrapper] = e.detail;
			window.dispatchEvent( new CustomEvent( 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', { detail: [cardsWrap] } ) );

			return true;
		}

		/**
		 * Initialize comparison-row behavior.
		 *
		 * @param {'accordion'|'collapsible'|'popover'} mode
		 * @param {Element} fixedCon   Container for the fixed‐column side
		 * @param {Element} sliderCon  Container for the slider side
		 */
		function initComparisonRows( mode = 'accordion', fixedCon, sliderCon ) {
			if ( !fixedCon || !sliderCon ) {
				return;
			}

			// collect only rows with non-empty descriptions
			const allRows = Array.from( fixedCon.querySelectorAll( '.comparison-row' ) )
			.filter( row => {
				const desc = row.querySelector( '.is-claim-description' );
				return desc && desc.textContent.trim();
			} );

			// POPPER-BASED POPOVER MODE
			// if (mode === 'popover') {
			// 	rows.forEach(row => {
			// 		const idx      = row.dataset.rowIndex;
			// 		const descEl   = row.querySelector('.is-claim-description');
			// 		const descText = descEl.textContent.trim();
			//
			// 		// hide inline
			// 		descEl.style.display = 'none';
			//
			// 		// reference elements: fixed row + slider counterparts
			// 		const refs = [ row, ...sliderCon.querySelectorAll(`.comparison-row[data-row-index="${idx}"]`) ];
			//
			// 		refs.forEach(refEl => {
			// 			// create an off-DOM popover element
			// 			const popEl = document.createElement('div');
			// 			popEl.className = 'custom-popover';
			// 			popEl.setAttribute('role', 'tooltip');
			// 			popEl.style.zIndex = 9999;
			// 			popEl.style.visibility = 'hidden';
			// 			popEl.innerHTML = `<div class="custom-popover__arrow" data-popper-arrow></div>
			//                  <div class="custom-popover__content">${descText}</div>`;
			// 			document.body.appendChild(popEl);
			//
			// 			// create a Popper instance (with auto placement)
			// 			const popperInstance = Popper.createPopper(refEl, popEl, {
			// 				placement: 'auto',
			// 				modifiers: [
			// 					{ name: 'offset', options: { offset: [0, 8] } },
			// 					{ name: 'arrow',   options: { element: '[data-popper-arrow]' } },
			// 				],
			// 			});
			//
			// 			// show on hover/focus
			// 			function show() {
			// 				popEl.style.visibility = 'visible';
			// 				popperInstance.update();
			// 			}
			// 			// hide on leave/blur
			// 			function hide() {
			// 				popEl.style.visibility = 'hidden';
			// 			}
			//
			// 			refEl.addEventListener('mouseenter', show);
			// 			refEl.addEventListener('focus', show);
			// 			refEl.addEventListener('mouseleave', hide);
			// 			refEl.addEventListener('blur', hide);
			// 		});
			// 	});
			// 	return;
			// }

			// ACCORDION or COLLAPSIBLE
			allRows.forEach( row => row.classList.remove( 'is-expanded' ) );

			allRows.forEach( row => {
				row.addEventListener( 'click', () => {
					// lock this row in place while we toggle + re-sync
					keepInPlace( row, () => {
						const idx = row.dataset.rowIndex;
						const isExpanded = row.classList.contains( 'is-expanded' );
						const counterparts = sliderCon.querySelectorAll(
							`.comparison-row[data-row-index="${idx}"]`
						);

						if ( mode === 'accordion' ) {
							// collapse all first
							allRows.forEach( r => r.classList.remove( 'is-expanded' ) );
							sliderCon.querySelectorAll( '.comparison-row' )
							.forEach( r => r.classList.remove( 'is-expanded' ) );
						}

						// toggle this row (and its slide siblings)
						if ( !isExpanded ) {
							row.classList.add( 'is-expanded' );
							counterparts.forEach( el => el.classList.add( 'is-expanded' ) );
						}

						// then re-sync heights
						matchRowHeights();
					} );
				} );
			} );

		}

		document.body.addEventListener( 'COLIBRI:Tabs:tabChanged', ( e ) => {
			if ( e.detail.tab ) {
				onResize();
			}
		} );

		if ( slidesCount > 2 ) {
			const config = {
				slidesPerView: colCount >= slidesCount
							   ? Math.min( slidesCount, 2.2 )
							   : ( + Math.min( colCount, 2 ) + 0.2 ),
				on: {
					init( s ) {
						matchRowHeights();
						updateFade( sliderCon, s );
						onResize();
					},
					slideChange( s ) {
						updateFade( sliderCon, s );
					},
					transitionEnd( s ) {
						updateFade( sliderCon, s );
					},
				},
				breakpoints: {
					1000: {
						slidesPerView: colCount >= slidesCount
									   ? Math.min( slidesCount, 3.2 )
									   : ( + Math.min( colCount, 3 ) + 0.2 )
					},
					1200: {
						slidesPerView: colCount >= slidesCount
									   ? Math.min( slidesCount, 4.2 )
									   : ( + Math.min( colCount, 4 ) + 0.2 )
					},
				}
			};
			swiperInstance = new Swiper( sliderCon, config );
		}

		// always run onResize once, so mobile<->desktop is set correctly immediately
		onResize();

		//'accordion' or 'collapsible' or 'popover'
		initComparisonRows( view.dataset.presentationMode || 'accordion', fixedCon, sliderCon );

		if ( swiperInstance ) {
			resizeHandlers.push( () => updateFade( sliderCon, swiperInstance ) );
		}
		resizeHandlers.push( onResize );
	}

	// ——————————————————————
	// Boot all views on load (or DOMContentLoaded)
	// ——————————————————————
	function boot() {
		document
		.querySelectorAll( '.product-comparison-view' )
		.forEach( grid => {
			//we need this class on the tabs container to avoid complications in setting slide sizes across breakpoints
			const tabsAncestor = grid.closest( '.wp-block-colibri-tabs' );
			if ( tabsAncestor ) {
				tabsAncestor.classList.add( 'alignfull' );
			}
			initComparisonView( grid );
		} );
	}

	if ( typeof window.swiper === 'undefined' ) {
		const link = document.createElement( 'link' );
		link.rel = 'stylesheet';
		link.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
		document.head.appendChild( link );

		const script = document.createElement( 'script' );
		script.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
		script.onload = boot;
		document.head.appendChild( script );
	} else if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}

} )();


